import { forwardRef } from "react";
import { PickersTextField as MuiPickersTextField, PickersTextFieldProps } from "@mui/x-date-pickers-pro";
import { alpha, styled } from "@mui/material";

const StyledPickersTextField = styled(MuiPickersTextField)((props) => {
  const unfocusedLabelColor = alpha(props.theme.palette.common.black, 0.54);
  const unfocusedBorderColor = alpha(props.theme.palette.common.black, 0.23);

  return {
    "& .MuiInputLabel-root": {
      "&.Mui-focused": {
        color: unfocusedLabelColor,
      },
    },
    "& .MuiInput-root": {
      "&.MuiInput-underline": {
        "&:before": {
          borderWidth: 1,
          borderColor: unfocusedBorderColor,
        },
        "&:hover:not(.Mui-disabled):before": {
          borderWidth: 2,
          borderColor: unfocusedBorderColor,
        },
      },
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderWidth: 1,
        borderColor: unfocusedBorderColor,
      },
      "&:hover:not(.Mui-disabled) fieldset": {
        borderWidth: 1,
        borderColor: props.color && props.theme.palette[props.color].main,
      },
      "&.Mui-focused fieldset": {
        borderWidth: 1,
      },
    },
  };
});

const PickersTextField = forwardRef<HTMLDivElement, PickersTextFieldProps<"standard">>((props, ref) => {
  const { variant = "standard", ...otherProps } = props;
  return (
    <StyledPickersTextField ref={ref} {...otherProps} InputLabelProps={{ shrink: true }} variant={variant} fullWidth />
  );
});

export default PickersTextField;
